
import React, { useState } from "react";
import {
  Container,
  Grid,
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Divider,
  Snackbar,
  Alert,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  useMediaQuery,
  useTheme
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import HelpIcon from "@mui/icons-material/Help";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const supportOptions = [
  { value: "general", label: "General Inquiry" },
  { value: "technical", label: "Technical Support" },
  { value: "billing", label: "Billing Issues" },
  { value: "feature", label: "Feature Request" },
  { value: "complaint", label: "File a Complaint" }
];

const ContactAndSupport = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    supportType: "general",
    message: ""
  });
  
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form validation (basic)
    if (!formData.name || !formData.email || !formData.message) {
      setSnackbar({
        open: true,
        message: "Please fill in all required fields",
        severity: "error"
      });
      return;
    }
    
    // Submit form logic would go here
    console.log("Form submitted:", formData);
    
    // Success message
    setSnackbar({
      open: true,
      message: "Your message has been sent! We'll get back to you shortly.",
      severity: "success"
    });
    
    // Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
      supportType: "general",
      message: ""
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <Box
    id="Home-Section-Five"
    sx={{ 
      bgcolor: "#f8f9fa", 
      py: 8,
      backgroundImage: "radial-gradient(circle at 10% 20%, rgba(216, 241, 230, 0.46) 0%, rgba(233, 226, 248, 0.46) 90.2%)"
    }}>
      <Container>
        <Grid container spacing={5} justifyContent="center">
          {/* Header Section */}
          <Grid item xs={12} textAlign="center">
            <Typography
              variant="h3"
              component="h2"
              sx={{
                fontWeight: 700,
                mb: 1,
                background: "linear-gradient(90deg, #3a7bd5 0%, #00d2ff 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              We're Here To Help
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mb: 4, maxWidth: "700px", mx: "auto" }}>
              Get in touch with our support team or find the information you need
            </Typography>
          </Grid>

          {/* Contact Cards */}
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ 
                  p: 3, 
                  borderRadius: 3,
                  height: "100%",
                  border: "1px solid rgba(0,0,0,0.08)",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
                  }
                }}>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                    <Box sx={{ 
                      bgcolor: "rgba(58, 123, 213, 0.1)", 
                      borderRadius: "50%", 
                      width: 70, 
                      height: 70, 
                      display: "flex", 
                      alignItems: "center", 
                      justifyContent: "center",
                      mb: 2
                    }}>
                      <PhoneIcon sx={{ fontSize: 32, color: "#3a7bd5" }} />
                    </Box>
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                      Call Us
                    </Typography>
                    <Typography color="text.secondary" sx={{ mb: 2 }}>
                      Talk to our friendly customer support
                    </Typography>
                   
                    <Typography variant="body2" color="text.secondary">
                      Mon-Fri: 9am-6pm EST
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ 
                  p: 3, 
                  borderRadius: 3,
                  height: "100%",
                  border: "1px solid rgba(0,0,0,0.08)",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
                  }
                }}>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                    <Box sx={{ 
                      bgcolor: "rgba(58, 123, 213, 0.1)", 
                      borderRadius: "50%", 
                      width: 70, 
                      height: 70, 
                      display: "flex", 
                      alignItems: "center", 
                      justifyContent: "center",
                      mb: 2
                    }}>
                      <EmailIcon sx={{ fontSize: 32, color: "#3a7bd5" }} />
                    </Box>
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                      Email Us
                    </Typography>
                    <Typography color="text.secondary" sx={{ mb: 2 }}>
                      Get a response within 24 hours
                    </Typography>
                    <Typography variant="body1" fontWeight={500} color="primary">
                      rockkpay@gmail.com
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      For any inquiry
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ 
                  p: 3, 
                  borderRadius: 3,
                  height: "100%",
                  border: "1px solid rgba(0,0,0,0.08)",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
                  }
                }}>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                    <Box sx={{ 
                      bgcolor: "rgba(58, 123, 213, 0.1)", 
                      borderRadius: "50%", 
                      width: 70, 
                      height: 70, 
                      display: "flex", 
                      alignItems: "center", 
                      justifyContent: "center",
                      mb: 2
                    }}>
                      <WhatsAppIcon sx={{ fontSize: 32, color: "#3a7bd5" }} />
                    </Box>
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                      Chat Support
                    </Typography>
                    <Typography color="text.secondary" sx={{ mb: 2 }}>
                      Get instant help from our team
                    </Typography>
                    <Button 
                      variant="outlined" 
                      color="primary" 
                      startIcon={<SupportAgentIcon />}
                      sx={{ borderRadius: 4, px: 2 }}
                    >
                      Start Live Chat
                    </Button>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Grid>

          {/* Contact Form Section */}
          <Grid item xs={12} sx={{ mt: 4 }}>
            <Paper elevation={0} sx={{ 
              borderRadius: 4, 
              overflow: "hidden",
              boxShadow: "0 5px 30px rgba(0,0,0,0.08)"
            }}>
              <Grid container>
                <Grid item xs={12} md={5} bgcolor="#3a7bd5" color="white" sx={{ 
                  p: 4,
                  background: "linear-gradient(135deg, #3a7bd5 0%, #00d2ff 100%)"
                }}>
                  <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
                      Get In Touch
                    </Typography>
                    
                    <Typography variant="body1" sx={{ mb: 4, opacity: 0.9 }}>
                      Have a question or need assistance? Fill out the form and our support team will get back to you as soon as possible.
                    </Typography>
                    
                    <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                      <LocationOnIcon sx={{ mr: 2 }} />
                      <Typography variant="body2">
                      PAYSTREAM TECHNOLOGY PRIVATE LIMITED<br />
                      Unit No.355, Plot No 4,Rohini Sector-14,<br/>NEW DELHI,Delhi,110085                      </Typography>
                    </Box>
                    
                    <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                      <EmailIcon sx={{ mr: 2 }} />
                      <Typography variant="body2">
                        rockkpay@gmail.com
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <PhoneIcon sx={{ mr: 2 }} /> 
                      <Typography variant="body2">
                      +91 8484934745
                      </Typography> 
                    </Box>
                    
                    <Box sx={{ mt: 8, display: { xs: "none", md: "block" } }}>
                      <HelpIcon sx={{ fontSize: 120, opacity: 0.2, ml: -3 }} />
                    </Box>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={7} sx={{ p: isMobile ? 3 : 5 }}>
                  <Typography variant="h5" fontWeight={600} mb={3}>
                    Send Us A Message
                  </Typography>
                  
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Your Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          variant="outlined"
                          sx={{ mb: 2 }}
                        />
                      </Grid>
                      
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Your Email"
                          name="email"
                          type="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          variant="outlined"
                          sx={{ mb: 2 }}
                        />
                      </Grid>
                      
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Phone Number (Optional)"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          variant="outlined"
                          sx={{ mb: 2 }}
                        />
                      </Grid>
                      
                      <Grid item xs={12}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel id="support-type-label">How can we help?</InputLabel>
                          <Select
                            labelId="support-type-label"
                            name="supportType"
                            value={formData.supportType}
                            onChange={handleChange}
                            label="How can we help?"
                          >
                            {supportOptions.map(option => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Your Message"
                          name="message"
                          multiline
                          rows={4}
                          value={formData.message}
                          onChange={handleChange}
                          required
                          variant="outlined"
                          sx={{ mb: 3 }}
                        />
                      </Grid>
                      
                      <Grid item xs={12}>
                        <Button
                          type="submit"
                          variant="contained"
                          fullWidth
                          size="large"
                          sx={{
                            py: 1.5,
                            borderRadius: 3,
                            background: "linear-gradient(90deg, #3a7bd5 0%, #00d2ff 100%)",
                            transition: "transform 0.3s",
                            "&:hover": {
                              background: "linear-gradient(90deg, #3a7bd5 0%, #00d2ff 100%)",
                              transform: "translateY(-3px)",
                              boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
                            }
                          }}
                        >
                          Send Message
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          
          {/* Help Center CTA */}
          <Grid item xs={12} sx={{ mt: 5, textAlign: "center" }}>
            <Divider sx={{ my: 4 }}>
              <Typography variant="body2" color="text.secondary" px={2}>
                OR
              </Typography>
            </Divider>
            
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Need more detailed help?
            </Typography>
            
            <Typography variant="body1" color="text.secondary" mb={3} sx={{ maxWidth: "600px", mx: "auto" }}>
              Visit our comprehensive help center with guides, tutorials, and frequently asked questions
            </Typography>
            
            <Button
              variant="outlined"
              color="primary"
              size="large"
              startIcon={<HelpIcon />}
              sx={{
                borderRadius: 3,
                px: 4,
                py: 1.5,
                borderWidth: 2,
                "&:hover": {
                  borderWidth: 2
                }
              }}
            >
              Visit Help Center
            </Button>
          </Grid>
        </Grid>
        
        {/* Snackbar for form submission feedback */}
        <Snackbar 
          open={snackbar.open} 
          autoHideDuration={6000} 
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert 
            onClose={handleCloseSnackbar} 
            severity={snackbar.severity} 
            variant="filled"
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </Box>
  );
};

export default ContactAndSupport;